import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="call-details"
export default class extends Controller {
  static targets = ["row", "panel"]

  selectRow(event) {
    const clickedRow = event.currentTarget
    const callId = clickedRow.dataset.callId

    // Update selected state
    this.rowTargets.forEach(row => {
      row.classList.remove("bg-blue-50", "border-l-4", "border-l-blue-500")
    })
    clickedRow.classList.add("bg-blue-50", "border-l-4", "border-l-blue-500")

    // Fetch and update details panel
    this.fetchCallDetails(callId)
  }

  async fetchCallDetails(callId) {
    try {
      const response = await fetch(`/dashboard/google-adwords-call-logs/${callId}`, {
        headers: {
          "Accept": "text/html",
          "X-Requested-With": "XMLHttpRequest"
        }
      })

      if (response.ok) {
        const html = await response.text()
        this.panelTarget.innerHTML = html
      }
    } catch (error) {
      console.error("Failed to fetch call details:", error)
    }
  }

  closePanel() {
    // Clear selection
    this.rowTargets.forEach(row => {
      row.classList.remove("bg-blue-50", "border-l-4", "border-l-blue-500")
    })

    // Show empty state
    this.panelTarget.innerHTML = `
      <div class="flex items-center justify-center h-full text-gray-500">
        <div class="text-center">
          <svg class="w-12 h-12 mx-auto mb-3 text-gray-300" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"/>
          </svg>
          <p class="font-medium">Select a call</p>
          <p class="text-sm text-gray-400">Click on a row to view details</p>
        </div>
      </div>
    `
  }
}
